<template>
  <el-card>
    <div class="main-page">
      <div class="title mb20 flex item-center">品牌活动页面</div>
      <div class="flex mb20">
        <div
          class="temp"
          v-for="item in activityList"
          :key="item.pageType"
        >
          <div class="temp-wrapper">
            <img :src="item.img" :alt="item.title" />
            <div class="temp-btn-wrapper">
              <div class="flex item-center wrapper">
                <div class="flex flex-wrap flex-start">
                  <el-tooltip
                    class="item"
                    content="编辑"
                    placement="top"
                    style="color: #0081E5"
                  >
                    <el-button
                      @click="toEditActivity(item)"
                      icon="hmicon icon-bianji"
                      circle
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    v-if="item.showHot"
                    class="item"
                    content="热力图"
                    placement="top"
                    style="color: #0081E5"
                  >
                    <el-button
                      @click="hotImage"
                      icon="hmicon icon-relitu"
                      circle
                    ></el-button>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
          <div class="temp-title">{{ item.title }}</div>
        </div>
      </div>
    </div>
    <el-dialog
      title="开启时间"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
    >
      <el-form
        ref="ruleForm"
        label-width="100px"
        :model="ruleForm"
        :rules="rules"
      >
        <el-form-item label="链接类型">
          <el-radio-group
            v-model="ruleForm.pageType"
            size="small"
            @change="switchPageType"
          >
            <el-radio label="index">首页</el-radio>
            <el-radio label="microPage">微页面</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="选择微页面"
          v-show="ruleForm.pageType === 'microPage'"
        >
          <el-select
            v-model="ruleForm.hrefAddress"
            placeholder="微页面名"
            size="small"
            filterable
            clearable
            class="mr10"
          >
            <el-option
              v-for="(v, i) in microPageList"
              :key="i"
              :label="v.name"
              :value="v.value"
            ></el-option>
          </el-select>
          <el-button
            :disabled="!ruleForm.hrefAddress"
            size="small"
            @click="createMpCode"
            >生成小程序码</el-button
          >
          <div class="form-tip danger">
            选择微页面并点击保存后小程序码才可以预览展示哦~~
          </div>
        </el-form-item>
        <el-form-item label="显示时间段" prop="enabledDate">
          <j-date-picker
            v-model="ruleForm.enabledDate"
            placeholder="请选择首页生效日期"
            :picker-options="pickerOptions"
            :show-lunar-control="false"
            rangeSeparator="-"
            :disabled="false"
            showLunarClass="MIX"
            type="DATERANGE"
            style="width: 220px"
            format="YYYY.MM.DD"
          ></j-date-picker>
        </el-form-item>
        <el-form-item label="是否开启" prop="labelInfo">
          <el-switch
            v-model="ruleForm.enabledState"
            active-text="开启"
            inactive-text="关闭"
            @change="switchEnabledState"
            active-color="#13ce66"
            active-value="open"
            inactive-value="close"
          ></el-switch>
        </el-form-item>
        <div class="flex flex-center">
          <el-button type="primary" @click="submitRuleForm" size="small"
            >保 存</el-button
          >
          <el-button @click="dialogVisible = false" size="small"
            >取 消</el-button
          >
        </div>
      </el-form>
    </el-dialog>

    <el-dialog
      title="请用微信扫一扫"
      :visible.sync="qrcodeDialogVisible"
      :modal="false"
      width="250px"
    >
      <div class="qrcode-wrapper">
        <img style="width:100%" :src="activityCode" alt="二维码" />
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { mapGetters } from "vuex";
// import { getLoginUser } from "@/utils/auth";
import JDatePicker from "vue-jlunar-datepicker";
import {getLoginUser, getUserName} from "@/utils/auth";

export default {
  components: { JDatePicker },
  data() {
    return {
      activityCode: "",
      qrcodeDialogVisible: false,
      type: "DATERANGE",
      showBackYears: 2,
      width1: "300",
      clearable: true,
      micropageId: "",
      currentMicropageId: "",
      microPageList: [],
      homeImg:
        "https://imgcdn.hemiao100.com/hemiaoBase/cdead4d7-3f67-43c5-85c1-5ee03c30f965.png",
      userCenterImg:
        "https://imgcdn.hemiao100.com/hemiaoBase/TIM%E6%88%AA%E5%9B%BE20190903104340.png",
      plusMemberImg: "",
      activityList: [
        {
          title: "美素佳儿活动",
          img: "https://imgcdn.hemiao100.com/mall/frisoImg.png",
          pageType: "frisonNu",
          showHot: true
        },
        {
          title: "雀巢活动",
          img: "https://imgcdn.hemiao100.com/mall/nestle_luodiye.jpg",
          pageType: "nestleState",
          showHot: false
        }
      ],
      ruleForm: {
        hrefAddress: "",
        pageType: "index",
        enabledDate: [],
        enabledState: "close"
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      rules: {
        enabledDate: {
          required: false,
          message: "请选择时间",
          trigger: "change"
        }
      },
      dialogVisible: false,
      openList: [],
      closeList: []
    };
  },
  computed: mapGetters(["indexTemp"]),
  filters: {
    tempTitle(pageType, row) {
      let type = "";
      if (pageType === "microPage") {
        type = "微页面" + row.hrefAddress.split("customPage")[1];
      } else {
        type = "首页";
      }
      return type;
    }
  },
  watch: {
    indexTemp(val) {
      if (val.layoutDefaultBoList) {
        val.layoutDefaultBoList.map(v => {
          if (v.previewImg) {
            if (v.pageType === "home") {
              this.homeImg = v.previewImg;
            } else if (v.pageType === "center") {
              this.userCenterImg = v.previewImg;
            } else if (v.pageType === "plus") {
              this.plusMemberImg = v.previewImg;
            }
          }
        });
      }
    }
  },
  mounted() {
    this.queryIndexTemp();
    this.queryMicroPageCount();
  },
  methods: {
    async queryIndexTemp() {
      const { result } = await this.$store.dispatch("queryIndexTemp");
      const { layoutCustomizeBoList } = result;
      let oldList = JSON.parse(JSON.stringify(layoutCustomizeBoList));
      let indexList = [];
      let customPageList = [];
      oldList.forEach(v => {
        if (v.pageType === "microPage") {
          customPageList.push(v);
        } else {
          indexList.push(v);
        }
      });
      //微页面排序
      customPageList.sort(function (a, b) {
        let val1 = a.hrefAddress.split("customPage")[1];
        let val2 = b.hrefAddress.split("customPage")[1];
        return val1- val2;
      });
      //重新组装数据  打开和关闭分组
      let openList = [];
      let closeList = [];

      indexList.forEach(v => {
        if (v.enabledState == "open") {
          openList.push(v);
        } else {
          closeList.push(v);
        }
      });

      customPageList.forEach(v => {
        if (v.enabledState == "open") {
          openList.push(v);
        } else {
          closeList.push(v);
        }
      });
      this.openList = openList;
      this.closeList = closeList;
    },
    async createMpCode() {
      // const { storeCode } = getLoginUser();
      const { storeCode } = getLoginUser();
      let userName = getUserName();
      let params = {
        path: `type=/${this.ruleForm.hrefAddress}`,
        storeCode: storeCode,
        createBy: userName,
        shareFunction: "店铺装修-品牌活动",
        shareFrom: "bg"
      }
      const url = await this.$store.dispatch("shareDataSaveV2", params);
      // let path =
      //   "article/customPage/customPage?type=/" + this.ruleForm.hrefAddress;
      // console.log("path: ", path);
      const { result } = await this.$store.dispatch("createCouponQrcode", {
        path: `article/customPage/customPage?saveUUID=${url.result}`
      });
      this.qrcodeDialogVisible = true;
      this.activityCode = result;
    },
    async queryMicroPageCount() {
      this.microPageList = [];
      const { result } = await this.$store.dispatch("queryMicroPageCount", {
        code: "microPage"
      });
      let value = 3;
      if (result && result.value) {
        value = result.value;
      }
      for (let i = 0; i < value; i++) {
        this.microPageList.push({
          name: "微页面" + (i + 1),
          value: "customPage" + (i + 1)
        });
      }
    },
    switchPageType() {
      this.ruleForm.hrefAddress =
        this.ruleForm.pageType === "index" ? "" : "customPage1";
    },
    switchEnabledState(state) {
      this.rules.enabledDate.required = state === "open";
    },
    setHome(row) {
      this.currentMicropageId = row.micropageId;
      if (row.enabledEndTime && row.enabledStartTime) {
        this.ruleForm.enabledDate = [row.enabledStartTime, row.enabledEndTime];
      } else {
        this.ruleForm.enabledDate = [];
      }
      if (row.enabledState) {
        this.ruleForm.enabledState = row.enabledState;
      }
      this.ruleForm.pageType = row.pageType || "index";
      this.ruleForm.hrefAddress =
        row.pageType === "index" ? "" : row.hrefAddress;
      this.dialogVisible = true;
    },
    submitRuleForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let enabledStartTime = "";
          let enabledEndTime = "";
          if (this.ruleForm.enabledDate && this.ruleForm.enabledDate.length) {
            enabledStartTime = this.ruleForm.enabledDate[0] + " 00:00:00";
            enabledEndTime = this.ruleForm.enabledDate[1] + " 23:59:59";
          }
          this.$store
            .dispatch("editTemp", {
              enabledStartTime,
              enabledEndTime,
              micropageId: this.currentMicropageId,
              enabledState: this.ruleForm.enabledState,
              pageType: this.ruleForm.pageType,
              hrefAddress:
                this.ruleForm.pageType === "index"
                  ? "/pages/index/index"
                  : this.ruleForm.hrefAddress
            })
            .then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.dialogVisible = false;
                this.queryIndexTemp();
              }
            });
        }
      });
    },
    edit() {
      this.$router.push({
        name: "Temp",
        query: {
          pageType: "home",
          pageModel: "default"
        }
      });
    },
    hotImage(){
      this.$router.push({
        name: "HotImg",
        query: {
          pageType: "home",
          pageModel: "default"
        }
      });
    },
    toEditUserCenter() {
      this.$router.push({
        name: "UserCenterTemp",
        query: {
          pageType: "center",
          pageModel: "default"
        }
      });
    },
    toEditPlusPage() {
      this.$router.push({
        name: "PlusPageTemp",
        query: {
          pageType: "plus",
          pageModel: "default"
        }
      });
    },
    // 编辑品牌活动
    toEditActivity(item) {
      this.$router.push({
        name: "FrisoTemp",
        query: {
          pageType: item.pageType,
          pageModel: "default"
        }
      });
    },
    deleteItem(micropageId) {
      this.$confirm(" 删除本条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("deleteTemp", {
            micropageId
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                type: "success",
                message: "操作成功！"
              });
            }
            this.queryIndexTemp();
          });
      });
    },
    toTemp(layoutId) {
      let query = {
        pageModel: "customize"
      };
      if (layoutId) {
        Object.assign(query, {
          layoutId,
          mode: "edit"
        });
      }
      this.$router.push({
        name: "Temp",
        query
      });
    }
  }
};
</script>
<style>
.full-jcalendar__body .day-cell .day-number .solar {
  height: 18px;
}
.full-jcalendar .input-icon {
  top: 0 !important;
}
.full-jcalendar__body {
  height: 346px !important;
}
</style>
<style lang="scss" scoped>
.title {
  position: relative;
  font-size: 14px;
  font-weight: bold;
  &::before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 14px;
    background: rgba(229, 0, 101, 1);
    border-radius: 2px 0px 2px 0px;
    margin-right: 5px;
  }
}

.temp {
  position: relative;
  margin-right: 20px;
  cursor: pointer;
  margin-bottom: 20px;
  &:hover {
    .temp-btn-wrapper {
      display: block;
    }
  }
  &-wrapper {
    height: 394px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &-title {
    background: #fff;
    font-size: 14px;
    font-weight: 500;
    width: 226px;
    text-align: center;
    padding: 11px 0;
  }
  &-btn-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 38px;
    height: 394px;
    padding-left: 35px;
    display: none;
    background: rgba(0, 0, 0, 0.8);
    .wrapper {
      height: 100%;
    }
    .el-button {
      margin: 0;
      margin-bottom: 20px;
      margin-right: 15px;
    }
  }
}
.temp {
  width: 226px;
  height: 423px;
  box-shadow: 0 1px 20px rgba(0, 0, 0, 0.1);
}

.temp.custom {
  .custom-wrapper {
    height: 394px;
    background: #ffd4e7;
    text-align: center;
    color: #e50065;
    font-size: 14px;
    .hmicon {
      font-size: 42px;
    }
  }
}
</style>
